import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  clearError as clearErrorReducer,
  fetchAdminData,
  login,
  logout,
  sendEmailOtp,
  verifyEmailOtp
} from "./actionCreator";
import initialState from "./state";

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: clearErrorReducer,
  },
  extraReducers: (builder) => {
    //LOGIN
    builder.addCase(login.pending, (state) => {
      state.loading = true;
        state.error = '';
    });
    builder.addCase(login.fulfilled, (state, action) => {
      // state.t_id = action?.payload;
      state.loading = false;
      state.error = "";
      localStorage.removeItem("key");

    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      if (localStorage.getItem("key") == 1) {
        // toast.error("Invalid Credentials", {
        //   position: "top-right",

        // });
        localStorage.setItem("key", "0")
      }
    });
      // Send OTP
      builder.addCase(sendEmailOtp.pending, (state) => {
        state.otpLoading = true;
        state.otpError = '';
      });
      builder.addCase(sendEmailOtp.fulfilled, (state, action) => {
        console.log("OTP sent successfully, payload:", action);
        
        state.otpLoading = false;
        state.verifyOtpToken = action?.payload?.Token;
      });
      builder.addCase(sendEmailOtp.rejected, (state, action) => {
        state.otpLoading = false;
        state.otpError = action?.payload || 'Failed to send OTP';
      });
      // Verify OTP
      builder.addCase(verifyEmailOtp.pending, (state) => {
        state.otpLoading = true;
        state.otpError = '';
      });
      builder.addCase(verifyEmailOtp.fulfilled, (state,  action) => {
        state.otpLoading = false;
        state.success = true;
        // state.t_id = window.localStorage.getItem('t_id');
        localStorage.removeItem("key");
    //     console.log("OTP verified successfully.",action);
        if(action?.payload?.data?.success == true ){
        state.t_id = window.localStorage.getItem('t_id');
          
    //     {toast.success(action.payload.message, {
    //       position: "top-right",
    //     });
    //   }
    //   state.t_id = window.localStorage.getItem('temp_token');
    }
    //   localStorage.removeItem("key");

      });
      builder.addCase(verifyEmailOtp.rejected, (state, action) => {
        state.otpLoading = false;
        state.otpError = action?.payload || 'Invalid OTP';
        toast.error(action?.payload?.message, {
          position: "top-right",
        });
      
      //     if (localStorage.getItem("key") == 1) {
      //   toast.error("Invalid Credentials", {
      //     position: "top-right",

      //   });
        localStorage.setItem("key", "0")
      // }
    });


    builder.addCase(fetchAdminData.pending, (state) => {
    state.loading = true;
    state.error = null;
  })
  builder.addCase(fetchAdminData.fulfilled, (state, action) => {
    state.loading = false;
    state.adminData = action.payload?.data || null;
    state.isSuperAdmin = action.payload.data?.isSuperAdmin || false;
    state.permissions = action.payload?.data?.permissions || [];
  })
  builder.addCase(fetchAdminData.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload || 'Failed to load admin data';
  });

    //LOGOUT
    builder.addCase(logout.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.t_id = null;
  state.loading = false;
  state.error = "";
  state.verifyOtpToken = null;
  state.success = true;
  state.otpError = '';
  state.otpLoading = false;
    });
    builder.addCase(logout.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action?.payload;
    });
  },
});

export const { clearError } = authSlice.actions;
export default authSlice.reducer;
